import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";

import { ModalPainel } from "@/components/ModalPainel";
import { Form } from "../children/Form";
import { FormValues } from "../model";
import { useFetchItem, useSave } from "../service";
import ModalRetorno from "@/components/components/ModalRetorno";

export function UsuarioEdit() {
  const { id } = useParams();
  const { data, isLoading, refetch } = useFetchItem(id || "");
  const { mutateAsync } = useSave(id);
  const navigate = useNavigate();

  const [isRetornoOpen, setIsRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState("");
  const [tipoRetorno, setTipoRetorno] = useState<"sucesso" | "erro">("sucesso");

  async function handleSave(values: FormValues) {
    try {
      await mutateAsync(values);
      setMensagemRetorno("Usuário atualizado com sucesso!");
      setTipoRetorno("sucesso");
      setIsRetornoOpen(true);
    } catch (e: any) {
      setMensagemRetorno(
        e?.response?.data?.mensagem ||
        JSON.stringify(e?.response?.data || e)
      );
      setTipoRetorno("erro");
      setIsRetornoOpen(true);
    }
  }

  const handleRefetchData = async () => {
    try {
      await refetch();
    } catch (error) {
      console.error("Erro ao recarregar dados:", error);
    }
  };

  return (
    <>
      <ModalPainel>
        <Form
          edit
          title="Editar Usuário"
          defaultValues={data}
          isLoading={isLoading}
          handleSave={handleSave}
          onRefetchData={handleRefetchData}
        />
      </ModalPainel>

      <ModalRetorno
        isOpen={isRetornoOpen}
        onClose={() => {
          setIsRetornoOpen(false);
          if (tipoRetorno === "sucesso") {
            navigate("/painel/cadastro-de-usuarios");
          }
        }}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}